module.exports = __webpack_public_path__ + "img/YR_2022_Checkmark-Done.48d04b7b.png";